import { StateCreator } from "zustand";

export interface PdfReaderState {
    pdfUrl: string;
}

export interface PdfReaderSlice {
    pdfReader: PdfReaderState;
    setPdfReader: (state: PdfReaderState) => void;
    setPdfUrl: (pdfUrl: string) => void;
    resetPdfReader: () => void;
}

const initialPdfReaderState: PdfReaderState = { pdfUrl: "" };

export const createPdfReaderSlice: StateCreator<PdfReaderSlice, [], [], PdfReaderSlice> = (set) => ({
    pdfReader: initialPdfReaderState,

    setPdfReader: (state) => set({ pdfReader: state }),
    setPdfUrl: (pdfUrl) => set({ pdfReader: { pdfUrl } }),
    resetPdfReader: () => set({ pdfReader: initialPdfReaderState }),
});

